import { Component, ErrorInfo, ReactNode } from "react";
import { DataVampire } from "../services/DataVampire";
import { BatchClassConfigStore } from "../stores/impl/BatchClassConfigStore";
import { AcceleratorBatchStore } from "../stores/impl/AcceleratorBatchStore";
import { AcceleratorDocStore } from "../stores/impl/AcceleratorDocStore";
import { ModelStore } from "../stores/impl/ModelStore";
import FileSaver from "file-saver";

type Props = {
  children: ReactNode;
};

type State = {
  hasError: boolean;
  error?: Error;
};
class ErrorBoundary extends Component<Props, State> {
  stores: string[] = [
    "BatchClassConfigStore",
    "AcceleratorBatchStore",
    "AcceleratorDocStore",
    "ModelStore",
  ];
  dataVampire: DataVampire;

  constructor(props: Readonly<{ children: ReactNode }>) {
    super(props);
    this.state = {
      hasError: false,
    };

    this.dataVampire = new DataVampire([
      BatchClassConfigStore,
      AcceleratorBatchStore,
      AcceleratorDocStore,
      ModelStore,
    ]);
  }
  /**
   * Sole purpose is to update state
   * @param error
   */
  static getDerivedStateFromError(error: Error) {
    console.log("Caught error", error);
    return {
      hasError: true,
      error,
    };
  }
  /**
   * Where async error handling should occur. Log to error reporting API here
   * @param error
   * @param errorInfo
   */
  componentDidCatch?(error: Error, errorInfo: ErrorInfo) {
    console.log(error);
    console.log(errorInfo);
  }

  downloadStores() {
    for (let i = 0; i < this.stores.length; ++i) {
      const [file, name] = this.createStore(i);
      FileSaver.saveAs(file, name, { autoBom: true });
    }
  }

  private createStore(index: number): [Blob, string] {
    const storeName = this.stores[index];

    const [dataVmpDumpName, jsonData] = this.dataVampire.getStoreInfo(index);

    const file = new Blob([jsonData], { type: "text/plain" });
    return [
      file,
      `${storeName}-${dataVmpDumpName}-${new Date().toISOString().split("T")[0]}.json`,
    ];
  }

  render() {
    if (this.state.hasError) {
      // create a hacky event
      // const event: IDialogBoxConfirmEvent = {
      //     callback: (val: any) => window.location = window.location,
      //     callbackCalled: false,
      //     labels: { no: 'No', yes: 'Yes' },
      //     message: 'Oops, an error occured!\n' +
      //         'Unfortunately, your progress has been lost',
      //     header: 'Unrepairable error encountered',
      //     type: 'DB_confirm',
      // }a
      // alert('Hello Dave. ')
      // fallback UI
      return (
        // <DialogBox
        //     rawEvent={event}
        //     type={event.type}
        //     header={event.header}
        //     message={event.message}
        //     onClick={event.callback} />
        <>
          <button
            onClick={() => {
              this.downloadStores();
            }}
          >
            Download Debug Information
          </button>
        </>
      );
      // return (<p>Oops, an error occured</p>);
    }
    return this.props.children;
  }
}

export { ErrorBoundary };
